import { Link } from "react-router-dom";

/**
 * Where per-client links live (they left agency Settings): one line with a link to the
 * client's Connections page (Setup tabs, Client settings). `what` starts the sentence,
 * for example "Google Ads and CTM accounts are linked".
 */
export default function ClientLinksNote({ what }: { what: string }) {
  return (
    <p className="client-links-line">
      {what} per client, on each client's <Link to="/client-settings">Connections page</Link>.
    </p>
  );
}
